export default "__VITE_ASSET__XRkrqxCn__"